import React from "react";
import { CircularProgress, makeStyles } from "@material-ui/core";

import "./Loader.css";


const useStyles = makeStyles(() => ({
    circle: {
        stroke: "url(#linearColors)"
    }
}));

export default function GradientLoader(props) {
    const classes = useStyles({});

    return (
        <>
            <svg width="00" height="00">
                <linearGradient id="linearColors" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="20%" stopColor="#108ee9" />
                    <stop offset="90%" stopColor="#87d068" />
                </linearGradient>
            </svg>
            <CircularProgress
                variant="determinate"
                // value={30}
                value={props.aiSelfieProgress}
                size={window.screen.width <= 320 ? 205 : 280}
                thickness={1}
                classes={{ circle: classes.circle }}
                className={props.positionClass}
                style={{ transform: 'rotate(-92.593deg)' }}
            />
        </>
    );
}
